export const NUMBER_OF_SOLD_GOODS = {
  id: 1,
  money: false,
  time: false,
  title: {
    id: 'NumberOfSoldGoods',
    defaultMessage: 'Number of sold goods'
  },
  legends: [
    {
      id: 'NumberOfSoldGoods',
      defaultMessage: 'Number of sold goods',
    },
  ],
  labelFields: [],
  valueFields: ['Mängd sålda varor'], // Number of sold goods
};

export const SALES_VAT = {
  id: 2,
  money: true,
  time: false,
  title: {
    id: 'SalesVAT',
    defaultMessage: 'Sales VAT',
  },
  legends: [
    {
      id: 'SalesInclVAT',
      defaultMessage: 'Sales incl VAT',
    }, {
      id: 'SalesExclVAT',
      defaultMessage: 'Sales excl VAT',
    },
  ],
  labelFields: [],
  valueFields: ['Försäljning inkl. moms', 'Försäljning exkl. moms'], // Sales incl. VAT, Sales excl. VAT
};

export const NET_SALES_VAT = {
  id: 7,
  money: true,
  time: false,
  title: {
    id: 'SalesVAT',
    defaultMessage: 'Sales VAT',
  },
  legends: [
    {
      id: 'SalesInclVAT',
      defaultMessage: 'Sales incl VAT',
    }, {
      id: 'SalesExclVAT',
      defaultMessage: 'Sales excl VAT',
    },
  ],
  labelFields: [],
  valueFields: ['Nettoförsäljning inkl. moms', 'Nettoförsäljning exkl. moms'],
};

export const RETURNS_VAT = {
  id: 3,
  money: true,
  time: false,
  title: {
    id: 'ReturnsVAT',
    defaultMessage: 'Returns VAT',
  },
  legends: [{
    id: 'ReturnsInclVAT',
    defaultMessage: 'Returns incl VAT'
  },{
    id: 'ReturnsExclVAT',
    defaultMessage: 'Returns excl VAT'
  },],
  labelFields: [],
  valueFields: ['Returer inkl. moms', 'Returer exkl. moms'], // Returns incl. VAT, Returns excl. VAT
};

export const SUM = {
  id: 4,
  money: true,
  time: false,
  title: {
    id: 'Sum',
    defaultMessage: 'Sum'
  },
  legends: [{
    id: 'Sum',
    defaultMessage: 'Sum'
  }],
  labelFields: [],
  valueFields: ['Summa'], // Sum
};

export const NUMBER_OF_DISCOUNTS =  {
  id: 5,
  money: false,
  time: false,
  title: {
    id: 'NumberOfDiscounts',
    defaultMessage: 'Number of discounts',
  },
  legends: [{
    id: 'NumberOfDiscounts',
    defaultMessage: 'Number of discounts',
  }],
  labelFields: [],
  valueFields: ['Antal rabatter'], // Number of Discounts
};

export const SALES_OVERVIEW = {
  id: 6,
  money: true,
  title: {
    id: 'SalesVAT',
    defaultMessage: 'Sales VAT',
  },
  labelFields: ['**TOTAL**|ANTAL KVITTON', 'Period'],
  valueFields: ['**TOTAL**|BELOPP'],
};

export const legendIDs = [
  NUMBER_OF_SOLD_GOODS.legends[0].id,
  SALES_VAT.legends[0].id, SALES_VAT.legends[1].id,
  RETURNS_VAT.legends[0].id, RETURNS_VAT.legends[1].id,
];

export const TOTAL_LABEL = 'Totalt';